// extracted by mini-css-extract-plugin
module.exports = {"section":"Section_section__1WU_O","title":"Section_title__2K4d1"};